<template>
    <!--
    1、普通用户即为：分销最高赚xx元的展示
    2、高级分销员展示：分销立赚（以对应等级的分销收益比例计算后的金额）元
    3、初级分销员展示：分销立赚（以对应等级的分销收益比例计算后的金额）元
    -->
<!--    <div class="" style="position: fixed; z-index: 3; top: 33%; right: 0;"-->
<!--         data-note="原来的'我要成为分销员'改为'我要分销'" v-show="isDistributionProduct">-->
<!--        <button class="button redBg borderBBB" style="display: block; width: 106px; height: auto; line-height: 24px;-->
<!--            padding: 6px 0; box-sizing: border-box; color: white; font-size: 16px; border-radius: 17px 0px 0px 17px;"-->
<!--            @click="view()">-->
<!--            分销立赚<br/>-->
<!--            <span style="font-size: 18px;">{{dataItem ? dataItem.money : ''}}元</span>-->
<!--        </button>-->
<!--    </div>-->
</template>

<script>
import generalCmpPart   from "@comp/part/generalCmpPart";
import orderBizTypeEnum from "@/data/orderBizTypeEnum";
import requestManager   from '@/components/platformApi/requestManager';
import consoleApi       from "@/components/platformApi/consoleApi";
import routeHelper      from "@/util/routeHelper";
import appHelper        from "@/util/appHelper";
import userApi from "@api/user";

const config = {
    apiConfig : {
        get : {
            url : 'portal/v2/distribution/product/getDistributionProductInfo',
            dataPath : 'data'
        }
    }
}

export default {
    name: "distributeButton",
    extends : generalCmpPart,
    props : {
        id : String,
        orderBizType : String
    },
    data() {
        return {
            apiConfig : config.apiConfig,
            visible : false,
            enableDataItem : true,
            isDistributionProduct : false,
            isSalesman : false
        }
    },
    methods : {
        onLoadDataItem() {

            this.isDistributionProduct = this.dataItem.exist;
            this.visible = true;
            if (this.isDistributionProduct)
            {
                consoleApi.log('[distributeButton] 是分销产品。');
            }
            else
            {
                consoleApi.log('[distributeButton] 不是分销产品。');
            }
        },
        show() {
            this.visible = true;
            this.isDistributionProduct = true;
        },
        view() {

            consoleApi.log('[distributeButton] 分销功能：微信分享网址带上用户的推广码 promotionCode');

            if (this.isSalesman)
            {
                // this.sharePoster();
                // appHelper.showHint('点击右上角菜单，分享给朋友，进行分销。');
                this.$emit('sharePoster');
            }
            else
            {
                appHelper.goToPage('distributorAuth');
            }
        },

        onUpdateParams() {
            if (this.id && this.orderBizType)
            {
                this.apiConfig.get.params = {
                    orderBizType : orderBizTypeEnum[this.orderBizType].code
                };
                this.loadDataItem(this.id);
            }
        }

    },
    mounted() {

        const me = this;

        appHelper.checkLogin((error, result) => {

            consoleApi.log('[distributeButton] check login callback');

            if (error)
            {
                return;
            }

            if (!result)   // 游客
            {
                consoleApi.log('result:', result);
                return;
            }

            requestManager.request({
                url : 'portal/v4/user/center/getAuthenticationStatus'
            }, (error, result) => {

                if (error)
                {
                    return;
                }

                if (result.errorCode) {
                    appHelper.showHint(result.msg);
                    return;
                }

                me.isSalesman = result.data.isSalesman;
            });
        });

    },
    watch : {
        id() {
            this.onUpdateParams();
        },
        orderBizType() {
            this.onUpdateParams();
        }
    }
}
</script>

<style lang="scss" scoped>
.redBg {
    background: #F42418;
}
.borderBBB {
    border: solid 1px #BBB;
}
</style>
